import { Controller } from 'stimulus'

export default class ProfileCompletionController extends Controller {
  static targets = ['progressBar']

  connect() {
    $(this.progressBarTarget).progress({
      autoSuccess: false,
      showActivity: false,
      label: '',
      total: 100
    })
  }
}
